import {
  IconStyleDictionary,
  IconStyleKey,
  SdProductStatusRowComponent,
  SdProductStatusRowComponentAccessoryResult,
  Typenames,
} from '@varo/graphql-schema-types';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';
import { ListItemProps } from 'shared/components/vxl/ListItem/ListItem';
import { ListItemLeadingAccessoryProps } from 'shared/components/vxl/ListItem/ListItemLeadingAccessory';
import { ListItemTextStackProps } from 'shared/components/vxl/ListItem/ListItemTextStack';
import { ListItemTrailingAccessoryProps } from 'shared/components/vxl/ListItem/ListItemTrailingAccessory';
import { propsFromTag } from 'shared/components/vxl/Tag/Tag.helpers';
import { VXLComponentId, VXLNode } from 'shared/renderer/types';
import { Maybe } from 'shared/utils/types';

const trailingAccessory = (
  accessory: Maybe<SdProductStatusRowComponentAccessoryResult>,
): Maybe<ListItemTrailingAccessoryProps> => {
  if (!accessory) {
    return null;
  }

  if (accessory.__typename === Typenames.Tag) {
    const props = propsFromTag(accessory);
    if (!props) {
      return null;
    }
    return {
      id: accessory.id,
      name: VXLComponentId.TAG,
      props,
    };
  } else if (accessory.__typename === Typenames.VXLText) {
    return {
      id: accessory.copy,
      name: VXLComponentId.LIST_ITEM_TEXT_STACK,
      props: {
        primaryCopy: accessory.copy,
      } satisfies ListItemTextStackProps,
    };
  }
};

const leadingAccessory = (
  accessory: Maybe<IconStyleDictionary>,
): Maybe<ListItemLeadingAccessoryProps> => {
  if (!accessory) {
    return null;
  }

  const { iconKey } = accessory;

  if (iconKey === IconStyleKey.LockMedium) {
    return {
      id: accessory.id,
      name: VXLComponentId.ICON,
      props: {
        iconKey: 'LOCK',
        iconSize: 'MD',
      } satisfies IconProps,
    };
  }

  return null;
};

const productStatusRowComponent = (
  component: SdProductStatusRowComponent,
  action: () => void,
): VXLNode => {
  const { title, accessory, icon } = component;

  return {
    id: title.copy,
    name: VXLComponentId.LIST_ITEM,
    props: {
      primaryCopy: title.copy,
      leadingAccessory: leadingAccessory(icon),
      trailingAccessory: trailingAccessory(accessory),
      showsChevron: false,
      onPress: action,
    } satisfies ListItemProps,
  };
};

export default productStatusRowComponent;
